import React, { FC } from 'react';
import { NavigationProps } from '@interfaces/navigation';
import MachinesProvider from '@v2/pages/machines/common/providers/MachinesProvider/MachinesProvider';
import { TimelineItemsList } from '@v2/pages/machines/modules/timeline/components/TimelineItemsList/TimelineItemsList';
// import { useTracking, TRACKING_EVENTS } from '../../../../../../../services/tracking';
import NCFileBatchEvents from '@v2/pages/common/components/NCFileBatchEvents';
import { NcFileBatchEventType } from '@v2/pages/common/enums';
import { useGetSelectedMachineIds } from '@v2/pages/common/hooks/useGetSelectedMachineIds';
import { useSelector } from 'react-redux';
import { selectSelectedItem } from '@reducers/machines';
import { View } from 'react-native';
import { SCREEN_PADDING_HORIZONTAL } from '@v2/pages/common/constants/base.constants';
import { scale } from '@components/frame';

interface MachineEventsCycleProps extends NavigationProps {}

const MachineEventsCycle: FC<MachineEventsCycleProps> = ({ lg }) => {
  // useTracking(TRACKING_EVENTS.EVENTS_OPENED);

  const machineIds = useGetSelectedMachineIds();

  const selectedMachine = useSelector(selectSelectedItem)

  return (
    <MachinesProvider
      lg={lg}
      panelViewMode={false} //TODO: remove this later
      onBack={() => {}}
      getList={(props) => <TimelineItemsList {...props} />}
    >
      <View style={{ paddingHorizontal: scale(SCREEN_PADDING_HORIZONTAL), flex: 1, }}>
      <NCFileBatchEvents eventType={NcFileBatchEventType.CYCLE} machineIds={machineIds} />
      </View>
      
    </MachinesProvider>
  );
};

export { MachineEventsCycle };
